<template>
    <div class="user-agreement">
        <!-- <div class="top-head">
      <button class="logout-button" @click="goBack">返回</button>
    </div> -->
        <h1 class="big">青牛出关-动漫网站用户协议</h1>
        <p>青牛出关-网站用户协议</p>
        <p>
            欢迎您使用青牛出关服务（以下简称本服务），您在使用本服务前请认真阅读以下协议（以下简称本协议）。
            青牛出关是指北京青牛出关科技有限公司。
        </p>
        <h2>一、青牛出关用户协议的接受</h2>
        <h3>1.</h3>
        <p>
            当您在注册程序过程中在“已阅读，同意本《用户协议》”处打勾“✓”并按照注册程序成功注册为青牛出关用户，或您以其他青牛出关允许的方式实际使用青牛出关服务时，即表示您已充分阅读、理解并接受本协议的全部内容，并与青牛出关达成协议。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款，请您重点阅读并理解加粗提示条款。如您对本协议项下任何条款有异议，请停止使用青牛出关服务。
        </p>
        <h3>2.</h3>
        <p>
            您确认您具备民事权利能力和完全民事行为能力，有能力同意并遵守本协议，并对您本协议项下的全部行为独立承担法律责任。若您不具备前述与您行为相适应的民事行为能力，则应获得法定监护人的同意。
        </p>
        <h3>3.</h3>
        <p>
            如您是未满18周岁的未成年人，在使用本产品或服务前，应在您的父母或其他监护人的监护、指导下共同仔细阅读本协议，并判断是否同意本协议。未成年人行使和履行本协议项下的权利和义务视为已获得法定监护人的同意。
        </p>
        <h3>4.</h3>
        <p>
            若你对本协议存在疑问，或者无法全部或者部分接受本协议，或者在使用过程中需要向青牛出关反馈（含建议、投诉、举报等），您可通过以下方式联系我们：客服邮箱help@picopi.cn
        </p>
          <h2>二、本协议的变更和修改</h2>
    <p>
      青牛出关有权随时对本协议进行修改，并且一旦发生协议条款的变动，青牛出关将以适当的方式（包括但不限于弹窗、网站公告等）提醒您更新的内容，以便您及时了解本协议的最新版本；用户如果不同意本协议的修改，可以放弃使用或访问本网站或取消已经获得的服务；如果用户选择在本协议变更后继续访问或使用本网站，则视为用户已经接受本协议的修改。
    </p>
    <h2>三、服务说明</h2>
    <h3>1.</h3>
    <p>
      青牛出关是一个向广大用户提供原创动漫产品的平台。
    </p>
    <h3>2.</h3>
    <p>
      青牛出关运用自己的系统通过互联网向用户提供服务，除非另有明确规定，增强或强化目前服务的任何新功能，包括新产品以及新增加的服务，均无条件地适用本协议。
    </p>
      <h2>四、用户行为</h2>
    <p>
      用户需要实名认证完成账号注册，才能正常使用网站提供的服务。任何机构或个人注册和使用的互联网用户账号，必须符合《互联网用户账号信息管理规定》等相关的法律、法规规定。
    </p>
    <h3>1、用户账号和安全</h3>
    <p>
      （1）您在注册账号时必须通过实名认证，才能成为青牛出关的合法用户。
    </p>
    <p>
      （2）用户须对在青牛出关的注册信息的真实性、合法性、有效性承担全部责任，当被发现用户冒用他人的名义恶意注册账号，青牛出关有权立即停止提供服务，收回其账号并由该用户承担由此而产生的一切法律及其他责任。
    </p>
    <p>
      （3）您理解并同意，根据《中华人民共和国网络安全法》《互联网用户账号信息管理规定》《互联网信息服务管理办法》等法律、行政法规的规定，青牛出关有权采用任何青牛出关认为有必要之措施，对您的账号信息进行审查，并采用包括但不限于屏蔽、删除、修改、等措施以保证信息呈现结果符合法律法规要求，维护清朗网络空间。
    </p>
    <p>
      （5）用户应采取合理措施维护其账号的安全。用户对利用该账号所进行的一切活动负全部责任；由该等活动所导致的任何损失或损害由用户承担，青牛出关不承担任何责任。
    </p>
    <p>
      （6）用户的账号遭到未授权的使用或发生其他任何安全问题，用户可以立即通知青牛出关，否则用户可能得不到青牛出关公司的安全保护。
    </p>
    <p>
      （7）对于用户长时间未使用的账号，青牛出关有权予以关闭。
    </p>
    <h2>五、关于个人信息保护</h2>
    <p>
      青牛出关深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。在您使用青牛出关提供的产品或服务的过程中，您同意按照青牛出关发布的隐私政策收集、使用、存储、共享、披露和保护您的个人信息。如青牛出关网站、客户端或关联公司的网站、客户端等未设独立隐私政策的，则其将参照适用青牛出关个人信息保护政策要求保护您的个人信息。若其向您提供的产品或服务单独设立隐私政策的，请在注册青牛出关用户前，仔细阅读青牛出关隐私政策，以了解青牛出关如何处理和保护您的个人信息。
    </p>
    <h2>六、版权声明</h2>
    <h3>1.</h3>
    <p>
      在未得到青牛出关的授权时，请不要将网站的动漫作品全部或部分复制发表到站外。用户应自行承担上述行为导致的不利后果。
    </p>
    <h3>2.</h3>
    <p>
      如个人或单位发现青牛出关上存在侵犯其自身合法权益的内容，请及时与青牛出关取得联系，并提供具有法律效应的证明材料，以便青牛出关作出处理。青牛出关有权根据实际情况依法删除相关的内容，并追究相关用户的法律责任。给青牛出关或任何第三方造成损失的，侵权用户应负全部责任。
    </p>
    <h3>3.</h3>
    <p>
      未经青牛出关许可，任何人不得复制、转载、盗链、上载、下载、展示青牛出关上的任何资源；不得复制或仿造本站或者在非青牛出关所属服务器上建立镜像。否则，青牛出关将依法追究法律责任。
    </p>
     <h2>七、免责声明</h2>
    <h3>1.</h3>
    <p>
      除青牛出关注明的服务条款外，其它因使用青牛出关而导致任何意外、疏忽、合约毁坏、诽谤、版权或知识产权侵犯及其所造成的各种损失（包括因下载而感染电脑病毒），青牛出关概不负责，亦不承担任何法律责任。
    </p>
    <h3>2.</h3>
    <p>
      青牛出关不保证（包括但不限于）：
    </p>
    <p>
      （1）本网站适合用户的使用要求；
    </p>
    <p>
      （2）本网站不受干扰，及时、安全、可靠或不出现错误；
    </p>
    <p>
      （3）用户经由本网站取得的任何产品、服务或其他材料符合用户的期望。
    </p>
    <h3>3.</h3>
    <p>
      本服务可能会包含与其他网站或资源的链接，即第三方链接。青牛出关对于前述网站或资源的内容、隐私政策和活动，无权控制、审查或修改，因而也不承担任何责任。建议您在离开青牛出关服务，访问其他网站或资源前仔细阅读其服务条款和隐私政策。
    </p>
    <h3>4.</h3>
    <p>
      因用户内容在本网站的上载或发布，而导致任何第三方提出索赔要求或衍生的任何损害或损失，由用户自行承担相应责任。
    </p>
    <h3>5.</h3>
    <p>
      青牛出关内会员所发言论仅代表网友自己，并不反映任何青牛出关之意见及观点。
    </p>
    <h3>6.</h3>
    <p>
      青牛出关认为，用户在进入青牛出关主页及各层页面时已经仔细看过本条款并完全同意。
    </p>
      <h2>八、法律适用和管辖</h2>
    <h3>1.</h3>
    <p>
      本协议的生效、履行、解释及争议的解决均适用中华人民共和国法律。本条款因与中华人民共和国现行法律相抵触而导致部分无效，不影响其他部分的效力。双方同意，解决争议时，应以您同意的最新版本的《用户协议》为准。
    </p>
    <h3>2.</h3>
    <p>
      如就本协议发生任何争议，应友好协商解决；协商不成，则各方均一致同意将争议提交被告所在地诉讼解决。
    </p>
    </div>
</template>
 <script>
export default {
  name: "WebUser",
  methods: {
    goBack() {
      this.$emit("go-back");
    },
  },
};
 </script>


<style scoped lang='less'>

.user-agreement {
  position: relative;
  z-index: 111;
  font-family: Arial, sans-serif;
  line-height: 1.6;
  color: #333;
  padding: 20px;
  max-width: 800px;
  margin: 100px auto;
}
.top-head {
  position: fixed;
  top: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  z-index: 11;
  padding: 5px;
  border-radius: 20px;

  .logout-button {
    padding: 10px 20px;
    background-color: #dc3545;
    border: none;
    border-radius: 6px;
    color: white;
    font-size: 14px;
    cursor: pointer;
    transition: background-color 0.3s ease;

    &:hover {
      background-color: #c82333;
    }
  }
}

.privacy-policy h1 {
  font-size: 24px;
  margin-bottom: 20px;
  text-align: center;
}
.big {
      text-align: center;
    font-weight: bold;
    font-size: 30px;

}
.privacy-policy h1,
.user-agreement h2,
.user-agreement h3 {
    font-weight: bold;
    color: black;
    margin-top: 10px;
}

.user-agreement p {
    color: black;
}
</style>


// WEBPACK FOOTER //
// src/components/web-user.vue